module.exports = __webpack_public_path__ + "static/media/lang3.7fae083d.mp3";